import { env } from 'config/env';
import { IssueType, TranslationType } from 'generated/graphql';
import {
  NotSelectedIssueType,
  NotSelectedTranslationType
} from 'stores/interfaces/CommonQueryState';

export const filterAllowedIssueTypes =
  (translationType: TranslationType | NotSelectedTranslationType) =>
  (issueType: IssueType | NotSelectedIssueType): boolean => {
    if (
      translationType === TranslationType.NOTES &&
      env?.REACT_APP_ALLOW_NOTES_QUERY_CREATION === 'true'
    ) {
      return [
        NotSelectedIssueType.NOT_SELECTED_ISSUE_TYPE,
        IssueType.SOURCE_EXPLAIN_MEANING,
        IssueType.SOURCE_OTHER_ISSUE,
        IssueType.SOURCE_ERROR,
        IssueType.SOURCE_SAPTERM_OTHER_ISSUE,
        IssueType.SOURCE_SHOULD_TEXT_BE_TRANSLATED,
        IssueType.SOURCE_INCORRECT_ORIGINAL_LANGUAGE,
        IssueType.SOURCE_MIXED_LANGUAGE,
        IssueType.SOURCE_NOT_FOUND,
        IssueType.TARGET_OTHER_ISSUE
      ].includes(issueType);
    }

    if (
      translationType === TranslationType.CORPORATE_CONTENT &&
      env?.REACT_APP_ALLOW_CORPORATE_CONTENT_QUERY_CREATION === 'true'
    ) {
      return [
        NotSelectedIssueType.NOT_SELECTED_ISSUE_TYPE,
        IssueType.SOURCE_EXPLAIN_MEANING,
        IssueType.SOURCE_OTHER_ISSUE,
        IssueType.SOURCE_ERROR,
        IssueType.SOURCE_SAPTERM_OTHER_ISSUE,
        IssueType.SOURCE_SHOULD_TEXT_BE_TRANSLATED,
        IssueType.TARGET_OTHER_ISSUE,
        IssueType.TARGET_INCONSISTENT_TRANSLATION,
        IssueType.TARGET_SAPTERM_ISSUE
      ].includes(issueType);
    }

    return (
      issueType === NotSelectedIssueType.NOT_SELECTED_ISSUE_TYPE ||
      ![IssueType.SOURCE_INCORRECT_ORIGINAL_LANGUAGE, IssueType.SOURCE_MIXED_LANGUAGE].includes(
        issueType
      )
    );
  };
